gsap.registerPlugin(ScrollTrigger);

let rem = getComputedStyle(document.querySelector("body")).fontSize.replace("px","");

let biglogoheight = getComputedStyle(document.querySelector(".big-logo")).height.replace("px","");

gsap.to("header", {
    scrollTrigger: {
        trigger: "main",
        start: "top 0",
        end: "+=100",
        scrub: 1,
        markers: false
    },
    marginTop: -1*biglogoheight-1+"px",
    duration: 2,
    ease: "power2.inOut"
});

gsap.to("nav", {
    scrollTrigger: {
        trigger: "main",
        start: "top 0",
        end: "+=100",
        scrub: 1,
        markers: false
    },
    top: .5*rem+"px",
    duration: 2,
    ease: "power2.inOut"
});


gsap.to(".big-logo", {
    scrollTrigger: {
        trigger: "main",
        start: "top 0",
        end: "+=100",
        scrub: 1,
        markers: false
    },
    opacity: "0",
    duration: 2,
    ease: "power2.inOut"
});


gsap.to("main", {
    scrollTrigger: {
        trigger: "main",
        start: "top 0",
        end: "+=100",
        scrub: 1,
        markers: false
    },
    paddingTop: 12*rem+"px",
    duration: 2,
    ease: "power2.inOut"
});

gsap.to(".header img", {
    scrollTrigger: {
        trigger: "main",
        start: "top 0",
        end: "+=100",
        scrub: 1,
        markers: false
    },
    opacity: "1",
    duration: 1.5,
    ease: "power2.inOut"
});

document.querySelector(".menu").addEventListener("click", () => {
    gsap.to("nav", {
        left: "-5px",
        duration: .3,
        ease: "power2.inOut"
    });  
})

document.querySelector(".close").addEventListener("click", () => {
    gsap.to("nav", {
        left: "-205px",
        duration: .3,
        ease: "power2.inOut"
    });  
})